import { getCategoryHref } from '../../utils/common/category';
import { DOCUMENT_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'documentTitleGeneratorType',
      analyticsName: 'document_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: DOCUMENT_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Document',
        value: getCategoryHref(DOCUMENT_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'documentTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'document_titles_generator',
      placeholder: 'Try "business plan for health tech startup" or "employment contract"',
      textLabel: 'Describe the document’s topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: DOCUMENT_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
